import { render, staticRenderFns } from "./AssignedAddressesPanel.vue?vue&type=template&id=372b4bee"
import script from "./AssignedAddressesPanel.vue?vue&type=script&lang=js"
export * from "./AssignedAddressesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports